import React from 'react';
import {Divider} from "antd";


export const SocialLoginBTNS = ({ title = 'Или войдите с помощью' }) => {
    return null;
    // return (
    //     <>
    //         <Divider plain>{title}</Divider>
    //         <div className="social_sign_in">
    //             <a className="social vk" href={"/profile/sign_in/vk"}>Войти с помощью VK</a>
    //             <a className="social yandex" href={"/profile/sign_in/yandex"}>Войти с помощь Yandex</a>
    //         </div>
    //     </>
    // );
}